(function(){
    angular
        .module('app')
        .directive('ngTooltip', tooltip);

        tooltip.$inject = ['$timeout'];
        function tooltip($timeout){
            return {
              scope:{
              },
            link: function (scope, element, $attrs) {
                return $timeout(function () {
                	console.log("si",element);
                 	$(element).tooltip();

                });
            }
          }
      }
})();